import { accountWebUrl } from '../../../../features/url/baseUrl';
import { BlockInnerTextButton } from '../../../Block/BlockInnerTextButton';
import { BlockTextAreaGray } from '../../../Block/BlockTextAreaGray';
import { InnerMargin } from '../../../Layout/InnerLayout/InnerMargin';

import type { InvalidParam } from '../../../../types/InvalidParam';
import type { AppEnv } from '@/packages/nurse-senka-frontend-sdk';
import type { FC } from 'react';

export type EmailAlterationInvalidParam = InvalidParam & {
  name: 'newEmail';
};

export type EmailAlterationInvalidParams = EmailAlterationInvalidParam[];

export type EmailAlterationSendMailContentsProps = {
  appEnv: AppEnv;
  newEmail: string;
};

// eslint-disable-next-line max-lines-per-function
export const EmailAlterationSendMailContents: FC<
  EmailAlterationSendMailContentsProps
> = ({ appEnv, newEmail }) => (
  <form>
    <BlockInnerTextButton
      button="secondary"
      buttonText="Myページへ"
      link={accountWebUrl(appEnv)}
    >
      <InnerMargin align="default">
        メールアドレス変更手続きを送信しました。メール本文のURLをクリックしてメールアドレスの変更手続きを行ってください。
      </InnerMargin>
      <BlockTextAreaGray title="メールが届かない場合">
        <ul>
          <li>「nurse-senka.jp」ドメインの受信を許可していますか？</li>
          <li>URL付きメールの受信を許可していますか？</li>
          <li>パソコンからのメール受信を許可していますか？</li>
          <li>迷惑メールフォルダに入っていませんか？</li>
          <li>入力されたメールアドレス（{newEmail}）が誤っていませんか？</li>
        </ul>
      </BlockTextAreaGray>
    </BlockInnerTextButton>
  </form>
);
